import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
    makeStyles,
    Dialog as MD,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
    lighten,
    withStyles,
    TextField as TF,
    DialogContent as DC,
    DialogTitle as DT,
    Paper as P, FormControlLabel as FCL, Select as SL,
    TableHead, TableRow, TableCell, TableSortLabel
} from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import {MuiPickersUtilsProvider as MuiPickers} from "@material-ui/pickers";
import Translate from "../utils/utils";

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0,
        "background-color": "white"
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "black",
    },
});

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
    },
    dense: {
        marginTop: theme.spacing(2),
    },
    menu: {
        width: 200,
    },
}));

const coreStyle = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const toolBarStyles = makeStyles(theme => ({

    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const DefaultToolBar = props => {
    const {numSelected = 0} = props;

    return (
        <Toolbar
            className={clsx(toolBarStyles.root, {
                [toolBarStyles.highlight]: numSelected > 0,
            })}
        >
            {numSelected > 0 ? (
                <Typography className={toolBarStyles.title} color="inherit" variant="subtitle1">
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography className={toolBarStyles.title} variant="h6" id="tableTitle">

                </Typography>
            )}

            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton aria-label="delete">
                        <DeleteIcon/>
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title="Filter list">
                    <IconButton aria-label="filter list">
                        <FilterListIcon/>
                    </IconButton>
                </Tooltip>
            )}
        </Toolbar>
    );
};

DefaultToolBar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const TextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#c32e95"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#c32e95"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#9f8a99"
            },
            "&:hover fieldset": {
                borderColor: "#c32e95"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#c32e95"
            }
        }
    },
})(TF);

const FormControlLabel = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#c32e95"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#c32e95"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#9f8a99"
            },
            "&:hover fieldset": {
                borderColor: "#c32e95"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#c32e95"
            }
        }
    },
})(FCL);

const Select = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#c32e95"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#c32e95"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#9f8a99"
            },
            "&:hover fieldset": {
                borderColor: "#c32e95"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#c32e95"
            }
        }
    },
})(SL);

TextField.className = `${clsx(useStyles.textField, useStyles.dense)}`;

const DialogTitle = withStyles(styles)(props => {
    const {children, classes, onClose, ...other} = props;
    return (
        <DT disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DT>
    );
});

const Dialog = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MD);


const DialogContent = withStyles(theme => ({
    root: {},
}))(DC);

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const {numSelected} = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
        </Toolbar>
    );
};

const MuiPickersUtilsProvider = withStyles(theme => ({}))(MuiPickers);

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
};

const Paper = () => {
    return (
        <P className={coreStyle.paper}/>
    );
};

const EnhancedTableHead = (props) => {
    const {
        headCells, rowCount, isLoading
    } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        padding={'normal'}
                    >
                        <TableSortLabel>
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
            {
                rowCount < 1 ?
                    <TableRow>
                        <TableCell colSpan={headCells.length} className="text-center">
                            {isLoading ? <i className="fa fa-hourglass-half"/> : <Translate id="TABLE.ACTIONS.NO_DATA"/>}
                        </TableCell>
                    </TableRow> : null
            }
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    headCells: PropTypes.array.isRequired,
    rowCount: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired
};


export {
    coreStyle,
    toolBarStyles,
    DefaultToolBar,
    TextField,
    DialogTitle,
    Dialog,
    DialogContent,
    useStyles,
    Paper,
    EnhancedTableHead,
    EnhancedTableToolbar,
    FormControlLabel,
    Select,
    MuiPickersUtilsProvider
};
